/**
 * @description Component-TradePositionTable
 */
import './index.less';

import React, { FC } from 'react';

import SkeletonTable, { SkeletonTableColumnsType } from '@/components/SkeletonTable';
import Table from '@/components/Table';

import { useChainId, useUserAddr } from '@/hooks/web3/useChain';

import { useMockDevTool } from '@/components/Mock';
import { PAIR_PAGE_TYPE } from '@/constants/global';
import { TRADE_TYPE } from '@/constants/trade';
import { useCurrentPairFromUrl } from '@/features/pair/hook';
import { useFetchPortfolioListFromApi } from '@/features/portfolio/query';
import { setTradeFormType } from '@/features/trade/actions';
import { useTradeStore } from '@/features/trade/store';
import { useAppDispatch } from '@/hooks';
import { useFilteredPositions } from '@/hooks/trade/useFilteredPositions';
import { useSideNavigate } from '@/hooks/useRouterNavigate';
import { useTranslation } from 'react-i18next';
import { TabKeys } from '../TradePortfolio/TradePortfolioTabs';
import { usePositionTableColumns } from './tableTitles';

interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
  isTradePage?: boolean;
}

const TradePositionTable: FC<IPropTypes> = function ({ isTradePage = true }) {
  const columnDefs = usePositionTableColumns();
  const { t } = useTranslation();
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const { pairPageNavigate } = useSideNavigate();
  // Fetch and filter positions for current pair
  const currentPair = useCurrentPairFromUrl(chainId);
  const positionList = useFilteredPositions({
    currentPair,
    isTradePage,
  });
  const { setShowTradeAreaOverlay } = useTradeStore();

  const { isFetched: isFetchedPortfolio } = useFetchPortfolioListFromApi(chainId, userAddr);
  const { isMockSkeleton } = useMockDevTool();
  const dispatch = useAppDispatch();
  return (
    <div className="trade-position-table-component-wrap">
      <SkeletonTable
        rowCount={10}
        loading={isMockSkeleton || !isFetchedPortfolio}
        columns={columnDefs as SkeletonTableColumnsType[]}>
        <Table
          requiredSkeleton
          className="syn-trade-positions"
          columns={columnDefs}
          dataSource={positionList}
          pagination={false}
          rowKey={(record) => record.id}
          onRow={(record) => ({
            onClick: () => {
              chainId && dispatch(setTradeFormType({ chainId, tradeType: TRADE_TYPE.MARKET }));
              setShowTradeAreaOverlay(undefined);
              pairPageNavigate(record.rootPair.symbol, PAIR_PAGE_TYPE.TRADE, undefined, {
                state: {
                  tab: TabKeys.POSITIONS,
                },
              });
            },
          })}
          // sticky={{ offsetHeader: 0 }}
          scroll={{ y: isTradePage ? 430 : 400, x: 1050 }}
          emptyDesc={t('common.empty.TradeNow')}
          emptyDescLink={'/#/trade'}
        />
      </SkeletonTable>
    </div>
  );
};

export default TradePositionTable;
